import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { GetEcshopAccountsRequestModel, GetEcshopAccountsResponseModel } from "@/features/accounts/ecshop/services/get-accounts-model";

export class GetEcshopAccountsApi {
  /**
   * その他連携サービス口座取得API
   */
  public getEcshopAccounts = async (
    param: GetEcshopAccountsRequestModel
  ): Promise<GetEcshopAccountsResponseModel[]> => {
    const path = `/api/ecshopaccounts/ecshops`;
    const res = await ApiClient.instance.get<GetEcshopAccountsResponseModel[]>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
